import process from 'node:process';

export const ABSOLUTE_BASE_URL = 'https://vatsim-petersburg.com';
export const OG_IMAGE_URL = 'https://cdn.vatsim-petersburg.com/0f31af56-8080-11f0-9908-0242ac130004';
export const OG_IMAGE_TYPE = 'image/png';
export const OG_IMAGE_WIDTH = '1200';
export const OG_IMAGE_HEIGHT = '569';

// if variable is set presume it's dev mode, elso prod and base_url contains client-side prod base
export const BASE_URL = (import.meta.env.PUBLIC_ENV__BASE_URL as string) || '/';
export const CORE_BASE_URL = !import.meta.env.SSR || BASE_URL !== '/' ? `${BASE_URL}api/core` : process.env.CORE_API_BASE_URL as string;
export const BOOKINGS_BASE_URL = !import.meta.env.SSR || BASE_URL !== '/' ? `${BASE_URL}api/bookings` : process.env.BOOKINGS_API_BASE_URL as string;
export const PLAN_BASE_URL = !import.meta.env.SSR || BASE_URL !== '/' ? `${BASE_URL}api/plan` : process.env.PLAN_API_BASE_URL as string;
export const APPLY_BASE_URL = !import.meta.env.SSR || BASE_URL !== '/' ? `${BASE_URL}api/apply` : process.env.APPLY_API_BASE_URL as string;
export const NAVIGATION_BASE_URL = !import.meta.env.SSR || BASE_URL !== '/' ? `${BASE_URL}api/navigation` : process.env.NAVIGATION_API_BASE_URL as string;

export const AUTH_URL = `${BASE_URL}api/core/auth/authorize`;

// export const CDN_DOWNLOAD_BASE_URL = `https://cdn${location.href.includes('dev') ? '-dev' : ''}.vatsim-petersburg.com`;
export const CDN_DOWNLOAD_BASE_URL = `https://cdn.vatsim-petersburg.com`;
export const STUB_IMAGE_ID = 'd2db3938-3930-11ef-bb0f-0242ac180007';

export const LOGO_URL = 'https://cdn.vatsim-petersburg.com/e0313a71-751a-11f0-9908-0242ac130004';

export const PRIVACY_POLICY_URL = `https://vatsim-petersburg.com/privacy_md/[lang].md`;
export const CREDITS_URL = `https://vatsim-petersburg.com/credits_md/[lang].md`;

export const APPLY_MAIL = 'apply@vatsim-petersburg.com';

export const RUSSIAN_SPEAKING_COUNTRIES = ['ru', 'by'] as const;

export const FEATURE_PUBLIC_ENABLE_APPLY = 'publicEnableApply';
export const FEATURE_PUBLIC_ENABLE_FEEDBACK = 'publicEnableFeedback';
export const FEATURE_PUBLIC_ENABLE_WEATHER = 'publicEnableWeather';

export const DISCORD_LINK = 'https://discord.vatsim-petersburg.com';
